
import { Base } from '../base-component';
import Slider from '../slider/slider.component';

import './our-campaigns.component.scss';



export class OurCampaigns extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;

	constructor(element: Element ) {
		super(element);
	}

	init() {

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');

		this.sliderConfig = {
			slidesPerView: 2,
			spaceBetween: 30,
			initialSlide: 0,
			breakpoints: {
				1200: {
					initialSlide: 0,
					slidesPerView: 1.8,
					spaceBetween: 30,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 1.2,
					spaceBetween: 15,
				}
			},
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/our-campaigns/our-campaigns.component.ts